window.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe !== 'function' && typeof PUB_SUB_EVENTS !== 'object') return;
  return subscribe(PUB_SUB_EVENTS.variantChange, (evt) => {
    // Other js refreshes the DOM on variant change, so we need to get DOM elements inside the callback
    const colorLabelElement = document.querySelector('.color-label-container');
    const colorLabelDisplay = colorLabelElement?.querySelector('.color-label-display');
    if (!colorLabelDisplay) return;
    const variant = evt.data.variant;
    if (!variant) return;
    const option2 = variant.option2;
    // Color is not an option, should return
    if (!option2) return;
    const allColors = colorLabelElement?.getAttribute('data-colors');
    if (!allColors) return;
    const colorLabels = allColors.split(',');
    // match option2 to a color label
    const matchedColor = colorLabels.find((color) => color.toLowerCase() === option2.toLowerCase());
    if (!matchedColor) return;

    colorLabelDisplay.textContent = matchedColor;
  });
});
